import React from 'react';
import { IconSvgProps } from '@models/common';

const GrammarChecker: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.865 10.2203V5.39703C15.865 4.89998 16.2683 4.49664 16.7654 4.49664C17.2624 4.49664 17.6658 4.89998 17.6658 5.39703V10.2203C17.6655 10.7171 17.2623 11.1197 16.7654 11.1197C16.2685 11.1197 15.8652 10.7171 15.865 10.2203Z'
        fill='currentColor'
      />
      <path
        d='M15.8655 7.80817C15.8653 6.97357 15.1884 6.29742 14.3538 6.29742C13.5192 6.29757 12.8432 6.97366 12.843 7.80817C12.843 8.6428 13.5192 9.31974 14.3538 9.31989C15.1885 9.31989 15.8655 8.64289 15.8655 7.80817ZM17.6653 7.80817C17.6653 9.63701 16.1826 11.1197 14.3538 11.1197C12.525 11.1195 11.0422 9.63692 11.0422 7.80817C11.0424 5.97954 12.5251 4.49679 14.3538 4.49664C16.1825 4.49664 17.6651 5.97945 17.6653 7.80817Z'
        fill='currentColor'
      />
      <path
        d='M7.38574 10.2198V4.48541C7.38567 3.95216 7.17388 3.44066 6.79688 3.06354C6.41966 2.68633 5.90748 2.47467 5.37402 2.47467C4.84066 2.47474 4.3293 2.68639 3.95215 3.06354C3.575 3.44069 3.36335 3.95205 3.36328 4.48541V10.2198C3.36328 10.7168 2.95995 11.1202 2.46289 11.1202C1.96583 11.1202 1.5625 10.7168 1.5625 10.2198V4.48541C1.56257 3.47466 1.96497 2.50579 2.67969 1.79108C3.3944 1.07636 4.36327 0.67396 5.37402 0.673889C6.38487 0.673889 7.35456 1.0763 8.06934 1.79108C8.78391 2.50577 9.18548 3.47477 9.18555 4.48541V10.2198C9.18555 10.7167 8.78299 11.1199 8.28613 11.1202C7.78908 11.1202 7.38574 10.7168 7.38574 10.2198Z'
        fill='currentColor'
      />
      <path
        d='M8.28613 5.83484C8.78299 5.83508 9.18555 6.23832 9.18555 6.73523C9.18555 7.23214 8.78299 7.63538 8.28613 7.63562H2.46289C1.96583 7.63562 1.5625 7.23229 1.5625 6.73523C1.5625 6.23817 1.96583 5.83484 2.46289 5.83484H8.28613Z'
        fill='currentColor'
      />
      <path
        d='M9.0332 16.5104C9.53026 16.5104 9.93359 16.9137 9.93359 17.4108C9.93359 17.9078 9.53026 18.3112 9.0332 18.3112H2.46289C1.96583 18.3112 1.5625 17.9078 1.5625 17.4108C1.5625 16.9137 1.96583 16.5104 2.46289 16.5104H9.0332Z'
        fill='currentColor'
      />
      <path
        d='M13.0078 12.9746C13.5049 12.9746 13.9082 13.3779 13.9082 13.875C13.9082 14.3721 13.5049 14.7754 13.0078 14.7754H2.46289C1.96583 14.7754 1.5625 14.3721 1.5625 13.875C1.5625 13.3779 1.96583 12.9746 2.46289 12.9746H13.0078Z'
        fill='currentColor'
      />
      <path
        d='M16.886 14.8408C17.2278 14.48 17.7976 14.4649 18.1584 14.8066C18.5193 15.1484 18.5344 15.7182 18.1926 16.0791L15.1614 19.2793C14.9944 19.4556 14.7635 19.5571 14.5208 19.5605C14.2778 19.5638 14.0431 19.4687 13.8713 19.2969L12.3713 17.7969C12.0202 17.4454 12.0202 16.8758 12.3713 16.5244C12.7228 16.1729 13.2933 16.1729 13.6448 16.5244L14.4905 17.3701L16.886 14.8408Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default GrammarChecker;
